// extracted by mini-css-extract-plugin
export default {"actionWrapper":"NotPermittedAction__actionWrapper--__9S8zAVpjHVLSQyDmN_","actionWrapper--block":"NotPermittedAction__actionWrapper--block--IP5nWSRRu4zzonXyHIUF"};